export const scrollTopLeft = (table: HTMLElement) => {
  table.scrollTop = 0;
  table.scrollLeft = 0;
};